import { render, staticRenderFns } from "./Redesign.vue?vue&type=template&id=fad2acde&scoped=true&"
import script from "./Redesign.vue?vue&type=script&lang=js&"
export * from "./Redesign.vue?vue&type=script&lang=js&"
import style0 from "./Redesign.vue?vue&type=style&index=0&id=fad2acde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad2acde",
  null
  
)

export default component.exports